<!-- 选择教室带冲突 -->
<template>
  <el-select
    :model-value="modelValue"
    @update:modelValue="(e) => $emit('update:modelValue', e)"
    :loading="loading"
    placeholder="请选择"
    size="large"
    :style="{ width: width }"
    :clearable="!config.multiple"
    :disabled="config.disabled"
    popper-class="classroom-checking-selector"
    filterable
  >
    <el-option v-for="item in list" :key="item.id" :value="item.id" :label="item.roomName">
      <template #default>
        <div class="status-line">
          <span
            >{{ item.roomName }}
            <span
            class="tag"
            :class="{ 'non-empty': item.checkConflictResult === 1 }"
            v-if="item.checkConflictResult !== 2"
            >
            {{ item.checkConflictResult === 1 ? '冲突' : '空闲' }}
          </span>
          <span class="tag disabled" v-if="item.status == 0"> 已停用 </span>
          </span>
          <span
            class="to-schedule"
            @click.stop="toSchedule(item)"
            v-if="item.checkConflictResult === 1 && op('coursePlan')"
          >
            查看上课时间
          </span>
        </div>
      </template>
    </el-option>
  </el-select>
</template>

<script>
import {
  ref,
  inject,
  watch,
  onUnmounted,
  // computed,
} from 'vue';
import { debounce } from 'lodash';

export default {
  props: {
    width: {
      type: String,
      default: '300px',
    },
    modelValue: {
      type: [Array, String, Number],
      default: () => [],
    },
    config: {
      type: Object,
      default() {
        return {
          multiple: false,
          disabled: false,
        };
      },
    },
    noPage: {
      type: Boolean,
      default: false,
    },
    queryParams: Object, // 额外的查询参数,有些接口需要
  },
  setup(props) {
    const api = inject('api');
    const loading = ref(false);
    const list = ref([]);
    const pageNum = ref(1);
    const totalPage = ref(1);
    const { formatDatetime } = inject('filters');

    // 原始查询数据函数
    async function queryDataOriginal() {
      const params = {
        page: {
          pageNum: pageNum.value,
          pageSize: 9999,
        },
      };

      if (props.noPage) {
        delete params.page;
      }
      if (props.queryParams) {
        Object.assign(params, props.queryParams);
      }

      loading.value = true;
      const { data, page } = await api.arrangeClassRoomList(params).finally(() => {
        loading.value = false;
      });
      list.value = [];

      if (props.noPage) {
        list.value = data || [];
      } else {
        totalPage.value = page?.totalPage || 0;
        list.value.push(...(data || []));
      }
    }
    
    // 使用debounce包装原始函数，300ms内只执行最后一次
    // 设置trailing为true确保最后一次请求一定会触发
    const queryData = debounce(queryDataOriginal, 300, {trailing: true});
    watch(() => props.queryParams, queryData, {
      immediate: true,
    });
    
    // 在组件卸载时取消未执行的防抖函数
    onUnmounted(() => {
      queryData.cancel();
    });
    return {
      list,
      loading,
      toSchedule(item) {
        window.open(
          `${window.location.origin + window.location.pathname + window.location.search}#/course-arrange-management?classRoomId=${item.id
          }&classRoomName=${item.roomName}&time=${formatDatetime(item.firstConflictDate,'yyyy-MM-dd')}`,
          '_blank',
        );
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.classroom-checking-selector {
  .status-line {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .tag {
      margin-right: 6px;
      display: inline-block;
      font-size: var(--fs-sm);
      line-height: var(--lh-sm);
      padding: 0 4px;
      color: #52C41A;
      background: rgba(234, 248, 227, 1);
      border-radius: 2px;
      &.non-empty {
        color: #FF4D4F;
        background: rgba(255, 233, 233, 1);
      }
      &.disabled {
        color: #fff;
        background: #c8c9cc;
      }
    }
    .to-schedule {
      color: var(--tlc);
    }
  }
}
</style>
